import { createClient } from '@/prismicio';
import { GeneralNavBarWrapperRedesign } from '@/components/common/GeneralNavBarWrapperRedesign';
import { FooterRedesign } from '@/components/common/FooterRedesign';
import { AnnouncementBar } from '@/components/common/AnnouncementBar';

const GeneralLayout = async ({ children }: { children: React.ReactNode }) => {
  const client = createClient();
  const { data: navData } = await client.getSingle('global_navigation');

  return (
    <div className="flex flex-col min-h-screen">
      <AnnouncementBar items={navData.announcement_bar} />
      <header
        className="sticky z-40 px-5 md:px-[30px] pt-2.5 mt-[-5.375rem]"
        style={{ top: 'calc(var(--announcement-bar-height, 0px) + 28px)' }}
      >
        <GeneralNavBarWrapperRedesign navData={navData} />
      </header>
      <main className="flex-1">{children}</main>
      <FooterRedesign navData={navData} />
    </div>
  );
};

export default GeneralLayout;
